import Login from "@/views/LoginPage.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/app",
    name: "LoginApp",
    component: Login,
  },
  {
    path: "/meus-materiais",
    name: "Materiais",
    component: () => import("@/views/MyMaterial.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cadastrar-material",
    name: "CadastrarMaterial",
    component: () => import("@/views/RegisterMaterial.vue"),
    meta: { requiresAuth: true },
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    next({ path: "/" });
    return;
  }
  next();
});

export default router;
